"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleSelectedValueFormatter = singleSelectedValueFormatter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _web = require("@react-hookz/web");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _flyout = require("../../flyout");
var _useDelayedOpen = require("../../flyout/hooks/useDelayedOpen");
var _OptionContactCard = require("../components/shared/OptionContactCard");
var _ValueRoot = require("../components/shared/ValueRoot");
var _ValueText = require("../components/shared/ValueText");
var _contactPickerConstants = require("../contactPickerConstants");
var _types = require("../types");
var _optionToString = require("./optionToString");
function singleSelectedValueFormatter(option, onViewMembers, focusRoot) {
  return /*#__PURE__*/_react.default.createElement(FormattedValue, {
    option: option,
    onViewMembers: (0, _types.isGroupContact)(option) ? onViewMembers : undefined,
    focusRoot: focusRoot
  });
}
const FormattedValue = _ref => {
  let {
    focusRoot,
    option,
    onViewMembers
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [isContactCardOpenOverride, setIsContactCardOpenOverride] = _react.default.useState(false);
  const {
    isOpen,
    getDelayedOpenTargetProps,
    setIsOpen
  } = (0, _useDelayedOpen.useDelayedOpen)({
    enterDelay: _contactPickerConstants.CONTACT_CARD_ENTER_DELAY,
    // This opts the contact card out of the "batch" functionality which interacts with
    // other delayed-open-and-floating elements like tooltips.
    delayMode: "each"
  });
  const {
    flyoutProps,
    targetProps
  } = (0, _flyout.useFlyout)({
    isOpen,
    onCloseRequested: () => setIsContactCardOpenOverride(false),
    placement: "bottom-start",
    hasArrow: false,
    offset: {
      distance: 0
    }
  });
  (0, _react.useEffect)(() => {
    const onKeyDown = e => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [setIsOpen]);

  // We need to make sure the ContactCard stays up when the user's mouse is on it.
  const finalContactCardIsOpen = flyoutProps.isOpen || isContactCardOpenOverride;
  const previousFinalContactCardIsOpen = (0, _web.usePrevious)(finalContactCardIsOpen);
  (0, _react.useEffect)(() => {
    // When the contact card finally does close, we want to reset the lock to ensure the
    // delayedOpen functionality can work again the next time the user hovers over an option.
    if (previousFinalContactCardIsOpen && !finalContactCardIsOpen) {
      setIsContactCardOpenOverride(false);
    }
  }, [previousFinalContactCardIsOpen, finalContactCardIsOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ValueRoot.ValueRoot, (0, _extends2.default)({
    themeMode: themeMode
  }, getDelayedOpenTargetProps({
    ...targetProps,
    onClick: focusRoot
  })), /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({}, flyoutProps, {
    isOpen: finalContactCardIsOpen,
    onCloseRequested: (0, _react.useCallback)(() => {
      setIsOpen(false);
    }, [setIsOpen])
  }), /*#__PURE__*/_react.default.createElement(_OptionContactCard.OptionContactCard, {
    onMouseEnter: () => setIsContactCardOpenOverride(true),
    onMouseLeave: () => setIsContactCardOpenOverride(false),
    onViewMembers: (0, _types.isGroupContact)(option) ? onViewMembers : undefined,
    option: option
  })), /*#__PURE__*/_react.default.createElement(_ValueText.ValueText, null, (0, _optionToString.optionToString)(option))));
};
//# sourceMappingURL=singleSelectedValueFormatter.js.map